import React, { useEffect, useState } from "react";
import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Edit, Trash2 } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";

function HotelBookingAndMarkup() {
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await axios.get(`${baseurl}/getAdminWalletTransactions`);
      if (response.data && response.data.transactions) {
        setTransactions(response.data.transactions);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: "100%" }}
                >
                  <h2 className="chart-title mb-0">Wallet Transactions</h2>
                </div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    {/* Table */}
                    <div className="table-responsive classic-table">
                      <table className="table table-striped table-hover">
                        <thead className="table-header">
                          <tr>
                            <th>#</th>
                            <th>User ID</th>
                            <th>User Type</th>
                            <th>Amount</th>
                            <th>Transaction Type</th>
                            <th>Transaction Reason</th>
                            <th>Booking For</th>
                            <th>Booking Id</th>
                            <th>GST </th>
                            <th>Created At</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          {transactions.map((transaction, index) => (
                            <tr key={transaction.id}>
                              <td>{index + 1}</td>
                              <td>{transaction.user_id}</td>
                              <td>{transaction.user_type}</td>
                              <td>{transaction.amount}</td>
                              <td>{transaction.transaction_type}</td>
                              <td>{transaction.transaction_reason}</td>
                              <td>{transaction.booking_for}</td>
                              <td>{transaction.booking_unique_id}</td>
                              <td>{transaction.gst} </td>
                              <td>{new Date(transaction.created_at).toLocaleString()}</td>
                              
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelBookingAndMarkup;